/** BCP-47 locale codes supported by the merchant portal. */
export type SupportedLocale = 'en' | 'ru' | 'zh-CN' | 'zh-TW' | 'de' | 'tr' | 'hi' | 'ja';

export const SUPPORTED_LOCALES: SupportedLocale[] = [
  'en',
  'ru',
  'zh-CN',
  'zh-TW',
  'de',
  'tr',
  'hi',
  'ja',
];

/** Labels shown in the LanguageSwitcher in native script. */
export const LOCALE_LABELS: Record<SupportedLocale, string> = {
  en: 'English',
  ru: 'Русский',
  'zh-CN': '中文 (简体)',
  'zh-TW': '中文 (繁體)',
  de: 'Deutsch',
  tr: 'Türkçe',
  hi: 'हिन्दी',
  ja: '日本語',
};

/** Fallback locale when nothing else is available. */
export const DEFAULT_LOCALE: SupportedLocale = 'en';

/** localStorage key for persisted user locale preference. */
export const LOCALE_STORAGE_KEY = 'obzr-merchant-locale';
